import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.reflect.get.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.array.reduce.js";
import { platform } from "./platform/getCurrentPlatform";
import conf from "./conf";
import { setCustomUrlHook } from "./utils/utils";
import messager from "./events/messager";
import pluginFactory from "./plugin/pluginFactory";
import hotFixFactory from "./plugin/hotFixFactory";
import CallZz from "./plugin/CallZZ";
export var Native = /*#__PURE__*/function () {
  function Native() {
    _classCallCheck(this, Native);

    this.config = Object.assign({
      disableCallApp: true
    }, window.nativeAdapterConfig);
    this.client = platform.name;
    this.scheme = platform.scheme || "";
    this.adapter = new platform.adapter();
    this.instanceGenerator(conf.instance);
    this._pluginTable = {};
    this.zzCaller = new CallZz({
      disable: this["in"]("zz") || this["in"]("app58") || this.config.disableCallApp
    });
  }

  _createClass(Native, [{
    key: "getClient",
    value: function getClient() {
      return this.client;
    }
  }, {
    key: "getScheme",
    value: function getScheme() {
      return this.scheme;
    }
  }, {
    key: "in",
    value: function _in(channel, cb) {
      typeof channel === "string" && (channel = [channel]); // 替换数组中的wa为miniprogram

      channel = channel.map(function (item) {
        if (item === "wa") return "miniprogram";
        return item;
      });

      if (~channel.indexOf(this.client)) {
        return cb ? cb() : true;
      } else {
        return false;
      }
    }
  }, {
    key: "inWx",
    value: function inWx(cb) {
      if (this.client === "miniprogram" || this.client === "wechat") {
        return typeof cb === "function" ? cb() : true;
      }
    }
  }, {
    key: "getUid",
    value: function getUid() {
      return this.adapter.getUid();
    }
  }, {
    key: "isLogin",
    value: function isLogin() {
      return this.adapter ? this.adapter.isLogin() : false;
    }
  }, {
    key: "getFormatPPU",
    value: function getFormatPPU() {
      return this.adapter.getFormatPPU();
    }
  }, {
    key: "replaceDomain",
    value: function replaceDomain(originUrl) {
      return this.adapter.replaceDomain(originUrl);
    }
  }, {
    key: "on",
    value: function on(adaterMethodName, cb) {
      messager.$on(adaterMethodName, cb);
    }
  }, {
    key: "ready",
    value: function ready(cb) {
      if (this.adapter.__loaded) return cb ? cb() : true;
      messager.$on("ready", cb);
    }
  }, {
    key: "_setCustomUrlHook",
    value: function _setCustomUrlHook(f) {
      setCustomUrlHook(f);
    }
  }, {
    key: "registerPlugin",
    value: function registerPlugin(pluginObj, key) {
      var _this = this;

      var prototype = this.constructor.prototype;

      if (this._pluginTable[key]) {
        console.error("native\u4E2D\u5DF2\u5B58\u5728\u81EA\u5B9A\u4E49\u63D2\u4EF6:".concat(key, ", \u53EF\u80FD\u4F1A\u5F15\u8D77\u5185\u90E8\u9519\u8BEF"));
        return;
      }

      this._pluginTable[key] = pluginFactory(pluginObj);
      Object.defineProperty(prototype, key, {
        get: function get() {
          var constructor = _this._pluginTable[key];

          if (typeof constructor === "function") {
            _this._pluginTable[key] = new constructor();
          }

          return _this._pluginTable[key];
        }
      });
    }
  }, {
    key: "hotFix",
    value: function hotFix(options) {
      hotFixFactory(this.adapter, options);
    }
    /**
     * 调起转转app，即将废弃，请通过@zz-common/call-app来实现吊起功能
     */

  }, {
    key: "CallZz",
    value: function CallZz() {
      for (var _len = arguments.length, argv = new Array(_len), _key = 0; _key < _len; _key++) {
        argv[_key] = arguments[_key];
      }

      this.zzCaller._invoke("callZz", argv);
    }
  }, {
    key: "disableGlobalVars",
    value: function disableGlobalVars(attr) {
      this.adapter._invokeCB(function () {
        if (!window.Proxy) return;
        var varb = window[attr];
        if (!varb) return;
        window[attr] = new Proxy(varb, {
          get: function get(target, key, receiver) {
            // 由于es6废弃了callee，故采用异常机制来追踪递归调用
            try {
              throw new Error();
            } catch (e) {
              if (!~e.stack.indexOf("Proxy.value")) {
                attr === "ZZAPP" ? console.error("\u65B9\u6CD5\u5DF2\u5E9F\u5F03\uFF0CZZAPP\u76F4\u8C03\u65B9\u6CD5\u5EFA\u8BAE\u91C7\u7528native.wrap(MethodNmae)(\u53C2\u65700, 1, 2...)\u7684\u5F62\u5F0F\uFF0C\u4F8B\u5982native.wrap('".concat(key, "')() \u7B49\u540C\u4E8EZZAPP.").concat(key, "()")) : console.error("window.".concat(attr, "\u5C06\u8981\u5728\u672A\u6765\u4E0D\u4E45\u540E\u5E9F\u5F03\u4F7F\u7528,\u5982\u679C\u4F60\u770B\u5230\u8FD9\u53E5\u8BDD\uFF0C\u8BF7\u8054\u7CFBnative-adapter\u7684\u7EF4\u62A4\u8005\u534F\u5546\u89E3\u51B3"));
              }
            }

            return Reflect.get(target, key, receiver);
          }
        });
      });
    }
  }, {
    key: "instanceGenerator",
    value: function instanceGenerator(instanceArr) {
      var _this2 = this;

      instanceArr = instanceArr.filter(function (m) {
        return !_this2[m];
      });
      Object.defineProperties(this, instanceArr.reduce(function (obj, method) {
        return obj[method] = {
          get: function get() {
            var _this3 = this;

            return function () {
              for (var _len2 = arguments.length, argv = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                argv[_key2] = arguments[_key2];
              }

              return _this3.adapter._invoke(method, argv);
            };
          }
        }, obj;
      }, {}));
    }
  }, {
    key: "wrap",
    value: function wrap(method) {
      var _this4 = this;

      return function () {
        for (var _len3 = arguments.length, argv = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
          argv[_key3] = arguments[_key3];
        }

        return _this4.adapter._invoke(method, argv);
      };
    }
  }, {
    key: "canIUse",
    value: function canIUse(method, obj) {
      var isAdapter = obj.isAdapter;

      if (isAdapter) {
        return !!this.adapter[method];
      } else {
        return !!(this.adapter[method] || this.adapter.__sdk && this.adapter.__sdk[method]);
      }
    }
  }]);

  return Native;
}();

var _native = window["native"] = new Native();

_native.disableGlobalVars("ZZAPP");

_native.version = process.env.VERSION;
export default _native;